import React from 'react';
import { Typography, Button, Box } from '@material-ui/core';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box display="flex" flexDirection="column" alignItems="center" mt={10}>
                    <Typography variant="h6" gutterBottom>
                        Ocurrió un error inesperado
                    </Typography>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.setState({ hasError: false })}
                    >
                        Reintentar
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
